export default __webpack_public_path__ + "static/media/bathroom.16a2c564.jpg";